import { createContext, useContext } from 'react'
import { es } from './dict'

export type Lang = 'en' | 'es'

const LangCtx = createContext<Lang>('en')
export const LangProvider = LangCtx.Provider
export const useLang = () => useContext(LangCtx)

/** Language is carried by the URL: /es and /es/* are Spanish, everything else English. */
export function langFromPath(pathname: string): Lang {
  return pathname === '/es' || pathname.startsWith('/es/') ? 'es' : 'en'
}

/** Strip the /es prefix to get the bare route (for active-link + close-band logic). */
export function barePath(pathname: string): string {
  if (pathname === '/es') return '/'
  if (pathname.startsWith('/es/')) return pathname.slice(3)
  return pathname
}

/** The same page in the other language (for the EN/ES switcher). */
export function otherLangPath(pathname: string): string {
  if (langFromPath(pathname) === 'es') return barePath(pathname)
  const bare = barePath(pathname)
  return bare === '/' ? '/es' : '/es' + bare
}

/**
 * Translate by English source string. In English it returns the string unchanged;
 * in Spanish it looks it up in the dictionary and falls back to English if missing
 * (so untranslated pages degrade gracefully to English under /es).
 */
export function useT() {
  const lang = useLang()
  return (s: string) => (lang === 'es' ? es[s] ?? s : s)
}
